import { render } from "./PushNotificationMaster.vue?vue&type=template&id=63ff1f44&scoped=true"
import script from "./PushNotificationMaster.vue?vue&type=script&lang=js"
export * from "./PushNotificationMaster.vue?vue&type=script&lang=js"

import "./PushNotificationMaster.vue?vue&type=style&index=0&id=63ff1f44&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ff1f44"]])

export default __exports__